export enum BaseDataGeneralType {
  RESIDENT_NUMBER = 'residentNumber',
  INDICATOR_NUMBER = 'alternativeIndicatorNumber',
  GENDER = 'gender',
  LAST_NAME = 'lastName',
  FIRST_NAME = 'firstName',
  DATE_OF_BIRTH = 'dateOfBirth',
  ROOM = 'room',
  STATION = 'station',
  LIVING_AREA = 'livingArea',
  CARE_LEVEL = 'careLevel',
  CARE_TYPE = 'careType',
  MOVE_IN_DATE = 'moveInDate',
  MOVE_OUT_DATE = 'moveOutDate',
  MOVE_OUT_REASON = 'moveOutReason',
  HEALTH_INSURANCE_COMPANY = 'healthInsuranceCompany',
  HEALTH_INSURANCE_NUMBER = 'healthInsuranceNumber',
  NOTES = 'notes',
}
